import {loadAppointmentReasons} from "@services/monolith/appointmentReasons";
import {PracticeId} from "src/constants/practiceIds";
import {actions} from "src/store";

import {NextPageContextWithStore} from "../../../store/types";

/**
 * This file is temporary because it should be removed once virtual care pages are merged into one page file.
 */
const getInitialProps = async ({store}: NextPageContextWithStore) => {
  const state = store.getState();

  const reasons = await (state.config.reasons
    ? Promise.resolve([])
    : loadAppointmentReasons(PracticeId.CARBON));

  const payload = {
    reasons: reasons.mapPick([
      "id",
      "slug",
      "name",
      "iconName",
      "description",
      "specialtyIds",
      "newPatientDuration",
      "supportsVideoVisit",
      "supportsInstantVisit",
      "practiceApptReasonSpecialties",
    ]),
  }.pickBy();

  store.dispatch(actions.setConfig(payload));

  return {};
};

export default getInitialProps;
